(function () {

  const CARD_BADGE_SELECTOR =
    '.product-label--sale[data-dmixer-theme-badge="true"]';
  const PDP_BADGE_SELECTOR =
    '.sale-badge[data-dmixer-theme-badge="true"]';
  const OWN_BADGE_SELECTOR =
    '[data-dmixer-theme-badge="true"]';

  // -----------------------------
  // ONLY DMIXER DETECTION
  // -----------------------------
  function hasDmixer(scope) {
    if (!scope) return false;

    return Boolean(
      scope.querySelector(
        '[data-dmixer-sale], dmixer-sale-badge, dmixer-discounted-price'
      )
    );
  }

  // -----------------------------
  // BADGES (ONLY FOR DMIXER)
  // -----------------------------
  function createCardBadge() {
    const el = document.createElement('span');
    el.className = 'product-label product-label--sale';
    el.setAttribute('data-dmixer-theme-badge', 'true');

    const inner = document.createElement('span');
    inner.textContent = 'SALE';

    el.appendChild(inner);
    return el;
  }

  function createPdpBadge() {
    const el = document.createElement('div');
    el.className = 'sale-badge';
    el.setAttribute('data-dmixer-theme-badge', 'true');

    const inner = document.createElement('h1');
    inner.textContent = 'SALE';

    el.appendChild(inner);
    return el;
  }

  // -----------------------------
  // COLLECTION / HOME (DMIXER ONLY)
  // -----------------------------
  function processCard(card) {
    if (!card) return;

    const priceScope = card.querySelector(
      '.product-block__title-price'
    );

    if (!priceScope || !hasDmixer(priceScope)) return;

    const imageTarget =
      card.querySelector('.image .inner > a') ||
      card.querySelector('.image__primary');

    if (!imageTarget) return;

    const existing = imageTarget.querySelector(
      CARD_BADGE_SELECTOR
    );

    if (!existing) {
      imageTarget.appendChild(createCardBadge());
    }
  }

  // -----------------------------
  // PDP (DMIXER ONLY)
  // -----------------------------
  function syncPdp() {
    const scope = document.querySelector('#price');
    const target = document.querySelector('.main-img-link');

    if (!scope || !target) return;

    // Only add the badge when Dmixer is present.
    if (!hasDmixer(scope)) return;

    const existing = target.querySelector(PDP_BADGE_SELECTOR);

    if (!existing) {
      target.appendChild(createPdpBadge());
    }
  }

  // -----------------------------
  // STABLE RUNNER
  // -----------------------------
  let timeout = null;

  function run() {
    if (timeout !== null) {
      window.clearTimeout(timeout);
    }

    timeout = window.setTimeout(() => {
      timeout = null;

      document
        .querySelectorAll('.product-block__inner')
        .forEach(processCard);

      syncPdp();
    }, 200);
  }

  // -----------------------------
  // OBSERVER
  // -----------------------------
  function isOwnBadgeNode(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) {
      return false;
    }

    const element = node;

    return (
      element.matches(OWN_BADGE_SELECTOR) ||
      Boolean(element.closest(OWN_BADGE_SELECTOR))
    );
  }

  function containsExternalMutation(mutations) {
    return mutations.some(mutation => {
      const changedNodes = [
        ...mutation.addedNodes,
        ...mutation.removedNodes
      ];

      return (
        changedNodes.length === 0 ||
        changedNodes.some(node => !isOwnBadgeNode(node))
      );
    });
  }

  function initObserver() {
    const root = document.body;
    if (!root) return;

    const observer = new MutationObserver(mutations => {
      // Ignore mutations caused solely by this script's badges.
      if (containsExternalMutation(mutations)) {
        run();
      }
    });

    observer.observe(root, {
      childList: true,
      subtree: true
    });
  }

  // -----------------------------
  // INIT
  // -----------------------------
  function init() {
    run();
    window.addEventListener('load', run, {once: true});
    initObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      {once: true}
    );
  } else {
    init();
  }

})();